module.exports = __webpack_public_path__ + "fonts/Rubik-Regular.9814ba8.ttf";